import { useMemo } from 'react';

import { keyOf, NameAndCreateDateFormatter } from '@Components/Grid/components/Table/formatters';
import column, { defaultActionsColumn, defaultActiveColumn, defaultColumn, defaultColumnId, editAction } from '@Components/Grid/utils/column';

import DeleteEntityFormatter from './DeleteEntityFormatter';
import ToggleFormatter from './ToggleFormatter';
import TwoFactorAuthenticationFormatter from './TwoFactorAuthenticationFormatter';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId({ maxSize: 100 }),
    defaultColumn('first_name', 'First Name'),
    defaultColumn('last_name', 'Last Name'),
    defaultColumn('email', 'Email', info => <NameAndCreateDateFormatter info={info} />),
    column.accessor('2fa', {
      header: '2fa',
      cell: info => <TwoFactorAuthenticationFormatter info={info} />,
      enableSorting: false,
      maxSize: 80,
    }),
    defaultActiveColumn(toggleFormatter),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}

function toggleFormatter(info) {
  return <ToggleFormatter key={keyOf(info)} info={info} />
}

export function deleteAction(info) {
  return <DeleteEntityFormatter key={keyOf(info, 'delete')} info={info} />
}
